import dayjs from 'dayjs'

export const readableDate = (date: string, format?: string) => {
  const defaultFormat = format ? format : 'DD/MM/YYYY'
  return dayjs(date).format(defaultFormat)
}

export const isInPast = (date: string) => {
  return dayjs(date).isBefore()
}
